<div class="right-panel-container"
  style="display: flex; flex-direction: column; overflow: auto; flex: none; height: 100%; justify-content: space-between; position: relative; width: 390px;">
  <div *ngIf="(currentTab$ | async) !== 'editor'" style="width: 390px; height: 100%; max-height: calc(100% - 50px);">
    <div class="tabs" style="display: flex; justify-content: space-between;">
      <div style="display: flex; height: 50px; flex-grow: 1;">
        <div (click)="go('coding')"
          style="font-size: 16px; display: flex; justify-content: center; align-items: center; flex-grow: 1; cursor: pointer;"
          [ngClass]="{'selected': (currentTab$ | async)==='coding'}">
          <div class="fad fa-ballot-check"
            [ngClass]="{'selected-icon': (currentTab$ | async)==='coding', 'icon':(currentTab$ | async)!=='coding'}">
          </div>
          <div style="font-size: 14px; padding-left:10px">Coding</div>
        </div>
        <div (click)="go('details')"
          style="font-size: 16px; display: flex; justify-content: center; align-items: center; flex-grow: 1; cursor: pointer;"
          [ngClass]="{'selected': (currentTab$ | async)==='details'}">
          <div class="fad fa-memo-circle-info"
            [ngClass]="{'selected-icon': (currentTab$ | async)==='details', 'icon':(currentTab$ | async)!=='details'}">
          </div>
          <div style="font-size: 14px; padding-left:10px">Metadata</div>
        </div>
      </div>
      <div style="display: flex; flex-grow: 1; justify-content: flex-end; align-items: center;">
        <button matTooltip="DocViewer Settings" mat-flat-button (click)="displaySettingsDialog()"
          class="settings-button" style="font-size: 16px; background: initial;">
          <div class="fad fa-cogs settings-icon"></div>
        </button>
      </div>
    </div>
    <div [ngSwitch]="currentTab$ | async" style="overflow: auto; height: calc(100% - 50px); overflow-x: hidden;">
      <lex-doc-viewer-coding-tab *ngSwitchCase="'coding'"></lex-doc-viewer-coding-tab>
      <lex-doc-viewer-doc-tab *ngSwitchCase="'details'"></lex-doc-viewer-doc-tab>
    </div>
  </div>
  <div *ngIf="(currentTab$ | async) === 'editor'" style="height:100%;">
    <lex-doc-viewer-editor-tab></lex-doc-viewer-editor-tab>
  </div>
  <lex-doc-viewer-bottom-right-bar></lex-doc-viewer-bottom-right-bar>
</div>